<template>
  <div>
    <el-dialog
      :visible.sync="newDialog"
      center
      :close-on-click-modal="false"
      @close="closeDialog"
      class="dialog_modal dialog_800"
      append-to-body
      :title="$t('SearchTrade.SupplyChainList')"
    >
      <div class="detail_cont">
        <div class="flex_center tab-margin-bottom">
          <ul class="flex_center Data-Management-ul" style="width: 100%">
            <li
              style="width: 50%; text-align: center"
              v-for="(item, index) in managementMenu"
              @click="MenuClick(item, index)"
              :class="{
                menuActiveColor: menuActive == item.value,
                font18: true,
                font_bold: menuActive == item.value,
                isDisabled: MenuDisabled[index],
              }"
              :key="index"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>
        <div class="table_box p_l_n">
          <el-table
            ref="treeTable"
            class="table_height_50 table_contentHeight_40 computer_right_cont_box"
            :data="managementTable1"
            border
            show-overflow-tooltip
            tooltip-effect="light"
          >
            <!-- 空数据状态的插槽 -->
            <template slot="empty"> {{ $t("SearchTrade.NoData") }} </template>
            <!-- <el-table-column
              :label="$t('SearchTrade.CompanyName')"
              prop="name"
              align="left"
              show-overflow-tooltip
              :resizable="false"
              class-name="company_link"
              tooltip-effect="light"
            >
              <template slot-scope="scope">
                <span class="">{{ scope.row.companyName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('SearchTrade.Destination')"
              v-if="menuActive == 1"
              prop="countryName"
              align="left"
              show-overflow-tooltip
              :resizable="false"
              tooltip-effect="light"
            />
            <el-table-column
              :label="$t('SearchTrade.Origin')"
              v-else
              prop="countryName"
              align="left"
              show-overflow-tooltip
              :resizable="false"
              tooltip-effect="light"
            /> -->

            <el-table-column label="#" align="center" width="120" type="index">
            </el-table-column>
            <el-table-column
              prop="companyName"
              :label="$t('Relationship.CompanyName')"
              min-width="200"
            >
              <template slot-scope="scope">
                <div class="flex_center_start_box">
                  <span class="link_hover_text" @click="goDetail(scope.row)">
                    {{ scope.row.companyName || "-" }}</span
                  >
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="totalTransactions"
              :label="$t('Relationship.TotalTradingVolume')"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                {{ scope.row.totalTransactions | FormatNum }}
              </template>
            </el-table-column>
            <el-table-column
              prop="ratioRounded"
              align="center"
              :label="$t('Relationship.TransactionTotal')"
              min-width="120"
            >
            </el-table-column>
          </el-table>
          <div class="page_i_box">
            <Page
              :totalFont="true"
              :total="pageTree.total"
              :pageSize.sync="pageTree.pageSize"
              :currentPage="pageTree.pageNo"
              @onPageChange="onPageChangeListTree"
            ></Page>

            <div class="search_rsult_txt line_2">
              {{ pageTree.pageNo }}-{{ pageTree.pageSize }} of over
              <span
                class="foundOverNum"
                :style="{ color: $store.state.app.themeColor }"
                >&nbsp;{{ pageTree.total | FilterNum }}&nbsp;</span
              >
              results for "{{ $t("SearchTrade.SupplyChainList") }}"
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog_footer">
        <button
          type="button"
          :style="{ 'background-color': btnColor }"
          class="el-close"
          @click="DetailsFormImport()"
        >
          <span>{{ $t("Toolbar.Export") }}</span>
        </button>
        <!--  <download-excel
          id="c0b0a6"
          :fetch="DetailsFormImport"
          :fields="json_fieldsImport"
          :name="localExportFileName"
        >
          
        </download-excel> -->
      </div>
    </el-dialog>

    <!-- 
    <el-dialog
      :visible.sync="exportFlag"
      center
      :close-on-click-modal="false"
      @close="backExport"
      class="dialog_modal dialog_800"
      append-to-body
      :title="$t('Toolbar.Export')"
    >
      <div>
        <div class="dialog_cont">
          <div class="flie_content_box">
            <div class="fileTips">
              How many results would you like to export form this search? You
              may also define your search by including additional filter(s).
            </div>
            <div class="file_group">
              <label class="file_label">File Name:</label>
              <el-input
                v-model="localExportFileName"
                placeholder="Please enter a file name"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="flex_center">
        <!-- <el-button class="btn_cancel btnbox" @click="backExport"
          >Cancel</el-button
        >
     
        <download-excel
                                  id="c0b0a6"
                                  :fetch="DetailsFormImport"
                                  :fields="json_fieldsImport"
                                  :name="localExportFileName"
                              >
          <el-button :style="{'background-color': btnColor}" 
          class="btn_export btnbox margin-left20"
            >Export</el-button
          >
        </download-excel>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { getSupplyChainList, getsearchExport } from "@/api/companyApi";

import { getSuspectedCustomerList } from "@/api/uboApi.js";
import Page from "@/components/page/index.vue";

export default {
  components: {
    Page,
  },

  props: {
    suoClose: {
      type: Boolean,
      //   default: false,
    },
    ContactObj: {
      type: Object,
    },
    IsCountry: {
      type: Boolean,
      default: false,
    },
    IsHsCode: {
      type: Boolean,
      default: false,
    },
    btnColor: {
      type: String,
      default: "",
    },

    PCM: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      pageTree: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      menuActive: 1,
      totalTemp: 0,
      tableTemp: [],
      managementTable1: [],
      //page: this.currentPage

      token: sessionStorage.getItem("token"),

      json_fieldsImport: {
        Date: "ie_date",
        Products: "hscode_description_inter",
        "Buyer Names": "import_name",
        Destination: "import_country_inter",
        "Supplier Names": "export_name",
        Origin: "export_country_inter",
        Amount: "amount",
      },
      exportFlag: false,
      MenuDisabled: [],
    };
  },
  computed: {
    managementMenu() {
      return [
        {
          label: this.$t("Relationship.PossibleClients"),
          value: "1",
        },
        {
          label: this.$t("SearchTrade.PossibleSuppliers"),
          value: "2",
        },
      ];
    },
    newDialog: {
      get() {
        if (this.suoClose) {
          this.searhinfoFirst();
        }
        return this.suoClose;
      },
      set() {},
    },
  },
  destroyed() {
    // bus.$off('handleShowLogin');
  },
  mounted() {},
  methods: {
    MenuClick(item, index) {
      if (!this.MenuDisabled[index]) {
        this.pageTree.pageNo = 1;
        this.pageTree.pageSize = 10;
        this.menuActive = item.value;
        this.searhinfo();
      }
    },
    onPageChangeListTree({ page, size }) {
      this.pageTree.pageNo = page;
      this.pageTree.size = size;
      this.searhinfo();
    },
    searhinfo() {
      // let params = {};
      // console.log(this.IsCountry);

      // params = {
      //   page: this.pageTree.pageNo,
      //   pageSize: this.pageTree.pageSize,
      //   tradeCode: this.IsHsCode ? this.ContactObj.hsCode : "",
      //   tradeType: this.menuActive,
      //   aaaid: this.IsHsCode ? "" : this.ContactObj.aaa_id,
      //   countryCode: this.IsHsCode ? "" : this.ContactObj.company_country,
      // };
      // getSupplyChainList(params).then((result) => {
      //   if (result.code == 200) {
      //     this.managementTable1 =
      //       result.data?.rows == undefined ? [] : result.data?.rows;
      //     this.pageTree.total =
      //       result.data?.total == undefined ? "" : result.data?.total;
      //   } else {
      //     this.managementTable1 = [];
      //     this.pageTree.total = 0;
      //   }
      // });
      let param = {
        aaaid: this.IsHsCode ? "" : this.ContactObj.aaa_id,
        type: this.menuActive,
        page: this.pageTree.pageNo,
        pageSize: this.pageTree.pageSize,
      };
      getSuspectedCustomerList(param)
        .then((res) => {
          if (res.code == 200) {
            this.managementTable1 = res.data.rows;
            this.pageTree.total = res.data.total;
          }
        })
        .catch((err) => {});
    },
    searhinfoFirst() {
      let param = {
        aaaid: this.IsHsCode ? "" : this.ContactObj.aaa_id,
        type: 1,
        page: 1,
        pageSize: 10,
      };
      getSuspectedCustomerList(param)
        .then((res) => {
          this.MenuDisabled[0] = false;
          this.MenuDisabled[1] = false;
          if (res.code == 200) {
            this.tableTemp = res.data.rows;
            this.totalTemp = res.data.total;
            if (this.totalTemp > 0) {
              this.MenuDisabled[0] = false;
            } else {
              this.MenuDisabled[0] = true;
            }
          } else {
            this.MenuDisabled[0] = true;
          }
          this.$nextTick(() => {
            param = {
              aaaid: this.IsHsCode ? "" : this.ContactObj.aaa_id,
              type: 2,
              page: 1,
              pageSize: 10,
            };
            getSuspectedCustomerList(param)
              .then((res) => {
                if (res.code == 200) {
                  if (res.data.total > 0) {
                    if (this.totalTemp == 0) {
                      this.tableTemp = res.data.rows;
                      this.totalTemp = res.data.total;
                      this.menuActive = 2;
                    }
                    this.MenuDisabled[1] = false;
                  } else {
                    this.MenuDisabled[1] = true;
                  }
                } else {
                  this.MenuDisabled[1] = true;
                }
                this.managementTable1 = this.tableTemp;
                this.pageTree.total = this.totalTemp;
              })
              .catch((err) => {});
          });
        })
        .catch((err) => {});
    },
    //关闭弹窗
    closeDialog() {
      this.pageTree.pageNo = 1;
      this.pageTree.pageSize = 10;
      this.menuActive = 1;
      this.$emit("clossuoDialogtwo", false);
    },

    getNowFormatDate() {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate(); // 获取当前日(1-31)
      if (month < 10) month = `0${month}`; // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}`; // 如果日是个位数，在前面补0

      return `${year}${month}${strDate}`;
    },
    backExport() {
      this.exportFlag = false;
    },

    DetailsFormImport() {
      this.chageItTrue = true;
      if (this.PCM[15].hasPrivilege) {
        getsearchExport({
          aaaid: this.IsHsCode ? "" : this.ContactObj.aaa_id,
        }).then((res) => {
          if (res.status === 200) {
            this.$message({
              type: "success",
            });

            const blob = new Blob([res.data], { type: "application/excel" });
            let fileName =
              this.ContactObj.file_name +
              "_Supply chain_" +
              this.getNowFormatDate();
            fileName += ".xlsx";

            const href = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = href;
            link.download = fileName;
            link.click();

            // 释放URL对象
            setTimeout(() => {
              URL.revokeObjectURL(href);
            }, 100);
          } else {
            this.$message({
              type: "error",
            });
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.detail_cont {
  max-height: 68%;
  /* overflow: auto; */
}
::v-deep .el-dialog__headerbtn {
  height: 18px !important;
  width: 18px !important;
  top: 20px !important;
  right: 20px !important;
}
::v-deep .el-dialog__body {
  padding: 20px !important;
  box-shadow: none;
}

.el-close {
  width: 210px;
  height: 60px;
  background: #009ea7;
  border-radius: 10px;
  color: #ffffff;
  font-size: 20px;
  font-family: "Arial Bold";
}

.tab-margin-bottom {
  margin-bottom: 11px;
}
::v-deep .el-table__header-wrapper {
  width: 100% !important;
  height: 49px !important;
  font-size: 18px !important;
  line-height: 24px !important;
}
::v-deep .el-table td.el-table__cell {
  height: 60px !important;
}
::v-deep .table_box .el-table th > .cell {
  padding-left: 10px !important;
}
::v-deep .el-table--border .el-table__cell:first-child .cell {
  padding-left: 20px !important;
  font-size: 18px !important;
}
::v-deep .el-table__body tr:hover > td {
  background-color: #eafafa !important;
}
::v-deep .el-table ::-webkit-scrollbar {
  height: 0px !important;
}
.search_rsult_txt {
  position: relative;
  width: auto;
  height: auto;
  font-size: 16px;
  top: 0;
}
.pageBox_right {
  height: 45px !important;
  font-size: 16px !important;
}
.dialog_800 >>> .el-dialog__footer {
  padding-top: 0;
}
.dialog_800 >>> .el-dialog__header {
  padding-bottom: 0;
  padding-top: 20px;
}
.dialog_800 >>> .el-dialog__title {
  font-family: "Arial Bold";
  font-size: 26px;
  line-height: auto;
  color: #1a2332;
}
.computer_right_cont_box {
  /* max-height: 440px; */
  overflow-y: auto;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #cccccc;
}
.page_i_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  align-items: center;
}

.computer_right_cont_box /deep/ .el-table__body-wrapper {
  overflow: auto;
  height: 600px !important;
}

.dialog_modal {
  overflow: auto !important;
}

.dialog_modal /deep/ .el-dialog {
  max-height: none;
}

.dialog_cont {
  display: flex;
  flex-direction: column;
  height: 100%;
  color: #1a2332;
}
.input_filter {
  position: relative;
  padding: 10px;
}
.icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20px;
  pointer-events: none;
  z-index: 9;
  font-size: 20px !important;
}
.flex {
  display: flex;
  width: 100%;
  height: 100%;
}
.right,
.left {
  background: #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
}
.left {
  width: 650px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
}
.right {
  width: 279px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.menu_box {
  display: flex;
  flex: 1;
  overflow: hidden;
}
.frist_menu_box {
  width: 360px;
  border-right: 1px solid #cccccc;
  overflow-x: hidden;
  overflow-y: auto;
}
.sec_menu_box {
  width: 289px;
  padding: 0 20px;
  overflow-x: hidden;
  overflow-y: auto;
}
.sec_menu_box /deep/ .el-checkbox__input.is-disabled .el-checkbox__inner {
  background-color: #1290c9;
  border-color: #1290c9;
}
.sec_menu_box
  /deep/
  .el-checkbox__input.is-disabled:not(.is-checked)
  .el-checkbox__inner {
  background-color: #ffffff;
  border-color: #999999;
}
.sec_menu_box
  /deep/
  .el-checkbox__input.is-disabled:not(.is-checked)
  .el-checkbox__inner::after {
  content: "";
}
.menu_box >>> .el-collapse-item__wrap {
  border-bottom: 0;
}
.menu_box >>> .el-collapse-item__header {
  position: relative;
  font-size: 18px;
  border-bottom: 0;
  background-color: transparent;
  padding: 8px 20px 8px 20px;
  line-height: 24px;
}
.menu_box >>> .el-collapse {
  border-top: 0;
  border-bottom: 0;
}
.new-dialog .frist_sub_li .el-checkbox {
  margin-bottom: 0;
}
.menu_box >>> .el-collapse-item__content {
  padding-bottom: 0;
}
.menu_box >>> .el-collapse-item__header.is-active {
  background-color: #fff;
  color: #1290c9;
}
.first_div {
  display: flex;
  height: 30px;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.first_div /deep/ .el-checkbox {
  margin-bottom: 0 !important;
}
.frist_sub_li {
  position: relative;
  padding: 5px 20px 5px 42px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.frist_sub_li span {
  width: 100%;
}
.frist_sub_li span div {
  width: 100%;
  text-overflow: break-word;
  white-space: normal;
  word-break: break-word;
}
.frist_sub_li .single {
  cursor: pointer;
}
.icon_right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
}
.top_select_title {
  padding: 20px;
  font-weight: bold;
  font-size: 18px;
  color: #1a2332;
  line-height: 30px;
}
.btn_reset_txt >>> span {
  font-family: "Arial Bold";
  font-size: 20px;
  color: #1290c9;
}
::v-deep .btn_reset_txt.is-disabled:hover,
::v-deep .btn_reset_txt.is-disabled {
  background: #fff;
  cursor: not-allowed;
}
::v-deep .btn_reset_txt.is-disabled span {
  color: #999;
}
.fileTips {
  font-size: 20px;
  color: #1a2332;
  line-height: 30px;
  font-style: normal;
  margin: 10px 0 30px;
}
.file_group {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}
.file_label {
  flex: none;
  margin: 14px 10px 10px 0;
  font-size: 20px;
}
.btn_cancel,
.btn_export {
  width: 210px;
  font-size: 20px;
}
.span-width {
  display: inline-block;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.selCol_item {
  position: relative;
  padding: 5px 15px 5px 20px;
  font-size: 18px;
  line-height: 30px;
}
.icon_cuowu {
  position: absolute;
  font-size: 12px !important;
  width: 18px;
  height: 18px;
  line-height: 18px;
  right: 0;
  top: 0;
  text-align: center;
  border-radius: 50%;
  color: #fff;
  background: #ff6a6a;
  transform: translateY(50%);
  margin-top: -3px;
}
.icon_suo {
  width: 16px;
  margin-left: 10px;
}
.input_filter >>> .el-input__inner {
  padding-left: 40px;
}
.file_group >>> .el-input__inner {
  width: 100%;
  font-size: 20px;
}
.sec_menu_box >>> .el-checkbox {
  margin: 10px 0;
}
.sel_frist_name {
  font-family: "Arial Bold";
  position: relative;
  padding-right: 45px;
}
.sel_sec_name {
  margin: 10px 10px;
  display: flex;
}
.frist_sub_li.has_sec >>> .single {
  color: #1290c9;
}
.sel_ul_Col_box {
  position: relative;
  flex: 1;
  overflow: auto;
}
::v-deep .el-dialog {
  width: 1000px !important;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  border-radius: 30px;
}
::v-deep .limit_height {
  display: flex;
  flex-direction: column;
  height: 80vh;
  min-height: 346px;
}
::v-deep .el-dialog__body {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}
::v-deep .el-input__inner {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #cccccc;
  color: #1a2332;
  height: 40px;
  font-size: 18px;
}
::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #999;
  opacity: 1;
}
::v-deep .el-input__inner:-moz-placeholder {
  color: #999;
  opacity: 1;
}
::v-deep .el-input__inner::-moz-placeholder {
  color: #999;
  opacity: 1;
}
::v-deep .el-input__inner:-ms-input-placeholder {
  color: #999;
  opacity: 1;
}
.export_dialog >>> .el-button {
  height: 60px;
}
::v-deep .el-checkbox__label {
  vertical-align: middle;
  font-size: 18px;
}
.frist_menu_box >>> .el-checkbox__label {
  max-width: 280px;
}
.sec_menu_box >>> .el-checkbox__label {
  max-width: 220px;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #1a2332;
}
::v-deep .el-collapse-item__arrow {
  margin: 0;
  position: absolute;
  right: 10px;
}
.sel_frist_name_box {
  display: flex;
  cursor: pointer;
}
.sel_col_icon_right {
  margin-left: 8px;
  transition: transform 0.3s ease;
}
.sel_col_icon_right.rotate {
  transform: rotate(180deg);
  color: #1290c9;
}
.sel_frist_name_box.open {
  color: #1290c9;
}
.sel_sec_name_box {
  height: 0;
  overflow: hidden;
  opacity: 0;
  transition: height 0.3s ease-out, opacity 0.3s ease-out;
}
.sel_sec_name_box.show {
  height: auto;
  overflow: auto;
  opacity: 1;
  transition: height 0.3s ease-in, opacity 0.3s ease-in;
}
::v-deep .btn_reset_txt + .el-button {
  margin-left: 0;
}
.btn_reset_txt {
  padding: 0 30px !important;
}
.el-button + .el-button {
  margin-left: 20px;
}
.Data-Management-ul li.isDisabled {
  cursor: not-allowed;
}
@media (max-width: 1920px) {
  .el-close {
    width: 157px;
    height: 45px;
    background: #009ea7;
    border-radius: 7px;
    color: #ffffff;
    font-size: 18px;
    font-family: "Arial Bold";
  }
  .tab-margin-bottom {
    margin-bottom: 8px;
  }
  ::v-deep .el-table td.el-table__cell {
    height: 50px !important;
  }
  ::v-deep .table_box .el-table th > .cell {
    padding-left: 7px !important;
  }
  ::v-deep .el-table--border .el-table__cell:first-child .cell {
    padding-left: 15px !important;
    font-size: 16px !important;
  }
  .search_rsult_txt {
    font-size: 14px;
  }
  .pageBox_right {
    height: 30px !important;
    font-size: 14px !important;
  }
  .pageBox {
    height: 40px !important;
  }
  .dialog_800 >>> .el-dialog__title {
    font-size: 20px;
  }
  .dialog_800 >>> .el-dialog__header {
    padding-top: 15px;
  }
  ::v-deep .el-dialog__body {
    padding: 15px !important;
  }
  .computer_right_cont_box {
    border-radius: 6px;
  }

  .computer_right_cont_box /deep/ .el-table__body-wrapper {
    height: 500px !important;
  }

  .left {
    width: 487px;
  }
  .frist_menu_box {
    width: 270px;
  }
  .sec_menu_box {
    width: 217px;
    padding: 0 15px;
  }
  .right {
    width: 209px;
  }
  .btn_cancel,
  .btn_export {
    width: 158px;
    font-size: 18px;
  }
  .btn_reset_txt >>> span {
    font-size: 18px;
  }
  .top_select_title {
    padding: 15px;
    line-height: 22px;
    font-size: 16px;
  }

  .icon {
    left: 15px;
  }
  .fileTips {
    line-height: 22px;
    margin: 7px 0 22px;
    font-size: 18px;
  }
  .file_group {
    margin-bottom: 30px;
  }
  .file_label {
    margin: 10px 7px 7px 0;
    font-size: 18px;
  }
  .selCol_item {
    padding: 5px 10px 5px 15px;
    font-size: 16px;
    line-height: 22px;
  }
  .icon_cuowu {
    width: 14px;
    height: 14px;
    line-height: 14px;
  }
  .icon_suo {
    width: 12px;
    margin-left: 7px;
  }
  .file_group >>> .el-input__inner {
    font-size: 18px;
  }
  .sec_menu_box >>> .el-checkbox {
    margin: 7px 0;
  }
  .input_filter >>> .el-input__inner {
    padding-left: 30px;
  }

  .menu_box >>> .el-collapse-item__header {
    font-size: 16px;
    padding: 7px 20px 7px 15px;
    line-height: 18px;
  }
  .first_div {
    height: 20px;
    gap: 6px;
  }
  .frist_sub_li {
    padding: 3px 20px 3px 35px;
    margin-bottom: 3px;
    gap: 6px;
  }
  .frist_sub_li span div {
    width: 100%;
    line-height: 20px;
  }
  .iconfont {
    font-size: 14px;
  }
  .sel_sec_name {
    margin: 7px 15px 7px 7px;
  }
  ::v-deep .el-dialog {
    width: 1000px !important;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
    border-radius: 22px;
  }
  ::v-deep .el-button {
    height: 45px;
    min-height: 45px;
  }
  ::v-deep .el-input__inner {
    border-radius: 7px;
    font-size: 16px;
    height: 30px;
  }
  ::v-deep .el-checkbox__label {
    font-size: 16px;
  }
  .frist_menu_box >>> .el-checkbox__label {
    max-width: 220px;
  }
  .frist_sub_li >>> .el-checkbox__label {
    max-width: 192px;
  }
  .sec_menu_box >>> .el-checkbox__label {
    max-width: 172px;
  }
  .btn_reset_txt {
    padding: 0 20px !important;
  }
  .el-button + .el-button {
    margin-left: 15px;
  }
}
@media (max-width: 1439px) {
  .el-close {
    width: 140px;
    height: 40px;
    background: #009ea7;
    border-radius: 6px;
    color: #ffffff;
    font-size: 16px;
    font-family: "Arial Bold";
  }
  ::v-deep .el-dialog__headerbtn {
    height: 18px !important;
    width: 18px !important;
    top: 20px !important;
    right: 20px !important;
  }
  .tab-margin-bottom {
    margin-bottom: 7px;
  }
  ::v-deep .table_box .el-table th > .cell {
    padding-left: 6px !important;
  }
  ::v-deep .el-table--border .el-table__cell:first-child .cell {
    padding-left: 13px !important;
    font-size: 14px !important;
  }
  .search_rsult_txt {
    font-size: 12px;
  }
  .pageBox_right {
    height: 30px !important;
    font-size: 12px !important;
  }
  .dialog_800 >>> .el-dialog__header {
    padding-top: 12px;
  }
  .dialog_800 >>> .el-dialog__title {
    font-size: 18px;
  }
  ::v-deep .el-dialog__body {
    padding: 12px !important;
  }
  .computer_right_cont_box {
    border-radius: 5px;
  }

  .left {
    width: 435px;
  }
  .frist_menu_box {
    width: 241px;
  }
  .sec_menu_box {
    width: 194px;
    padding: 0 13px;
  }
  .right {
    width: 186px;
  }
  .btn_cancel,
  .btn_export {
    width: 140px;
    font-size: 16px;
  }
  .btn_reset_txt >>> span {
    font-size: 16px;
  }
  .top_select_title {
    padding: 13px;
    line-height: 20px;
    font-size: 14px;
  }
  .icon {
    left: 13px;
  }
  .fileTips {
    line-height: 20px;
    margin: 6px 0 20px;
    font-size: 16px;
  }
  .file_group {
    margin-bottom: 26px;
  }
  .file_label {
    margin: 9px 6px 6px 0;
    font-size: 16px;
  }
  .selCol_item {
    padding: 5px 9px 5px 12px;
    font-size: 14px;
    line-height: 20px;
  }
  .icon_cuowu {
    width: 12px;
    height: 12px;
    line-height: 12px;
  }
  .icon_suo {
    width: 11px;
    margin-left: 6px;
  }
  .file_group >>> .el-input__inner {
    font-size: 16px;
  }
  .sec_menu_box >>> .el-checkbox {
    margin: 6px 0;
  }
  .input_filter >>> .el-input__inner {
    padding-left: 27px;
  }
  .menu_box >>> .el-collapse-item__header {
    font-size: 14px;
    padding: 6px 20px 6px 12px;
    line-height: 16px;
  }
  .frist_sub_li {
    padding: 3px 13px;
    margin-bottom: 3px;
  }
  .iconfont {
    font-size: 12px;
  }
  .sel_sec_name {
    margin: 6px 15px 6px 6px;
  }
  ::v-deep .el-dialog {
    width: 667px !important;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
    border-radius: 20px;
  }
  ::v-deep .el-button {
    height: 40px;
    min-height: 40px;
  }
  ::v-deep .el-input__inner {
    border-radius: 6px;
    font-size: 14px;
    height: 27px;
  }
  ::v-deep .el-checkbox__label {
    font-size: 14px;
  }
  .frist_menu_box >>> .el-checkbox__label {
    max-width: 180px;
  }
  .sec_menu_box >>> .el-checkbox__label {
    max-width: 155px;
  }
}
</style>
